import axios from 'axios'
import {apiDomain} from '../../config'

let axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
	    'token': localStorage.getItem('access_token')
	}
}

export default {
	getAll (filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/haul_report/', filter_by, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = ''
		          	if (response.data.status === 'success') {
										data = response.data
										resolve(data)
		          	}else{
										data = response.data
										resolve(data)
					}
		        })
		        .catch((error) => {
		          	reject(error)
		        })
		})
	},
	saveSelectedColumns ( selectColumns ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/haul_report/select_columns/', selectColumns, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	saveFilters ( filters ) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/haul_report/filters_reports/', filters, { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.message]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getFilters () {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/haul_report/reports_start/', { headers: {
				'Content-Type': 'application/json',
			    'token': localStorage.getItem('access_token')
			}})
				.then((response) => {
					var data = [response.data.status, response.data.filters_start]
					resolve(data)
				})
				.catch((error) => {
					reject(error)
				})
		})
	}
}



// WEBPACK FOOTER //
// ./src/views/reports/reports_service.js